export const environment = {
  production: true,
  authDomain: 'rex-login-prod01.cascadedesigns.com',
  authAudience: 'https://rexclientapi.cascadedesigns.com',
  authClientId: 'nWtE0ku1wRaJJxtU0s5WmOPsvBtRVA4F',
  authScope: 'openid profile create read update delete',
  redirect_uri: 'https://reports.cascadedesigns.com',
  api_url: 'https://cdireportsapi.cascadedesigns.com/api',
  ga_measurementId: 'G-846GQCRQBB',
};
